
import React, { useState, useEffect } from "react";
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Layout } from 'antd';
import './App.css';
import Clock from './components/Clock';
import Orders from './components/Orders';
import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  background-color: #2B2941;
  display: grid;
  grid-template-rows: 4fr 0.2fr;
  min-height: 100%;
`;

const Blink = ({ isOnline }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        marginRight: '25px',
        marginTop: '15px',
      }}
    >
      <div style={{
        marginRight: '5px',
        marginTop: '2px',
        color: '#fff',
        fontWeight: 'bold',
        fontSize: '.5em',

      }}>LIVE ORDERS</div>
      <svg
        fill="currentColor"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 32 32"
        width="2em"
        height="2em"
        style={{
          textSizeAdjust: 'none',
          listStyle: 'none',
          overflowWrap: 'break-word',
          textTransform: 'uppercase',
          color: '#006666',
          font: 'inherit',
          fill: 'currentcolor',
          width: '1em',
          height: '1em',
        }}
      >
        <path d="M16 4c6.6 0 12 5.4 12 12s-5.4 12-12 12S4 22.6 4 16 9.4 4 16 4zm0-4C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0z"></path>
        <circle
          cx="16"
          cy="16"
          r="8.5"
          className={`${(isOnline ? "live-order-PulsingCircle" : '')}`}
        >
        </circle>
      </svg>
    </div>
  )
};

function App({ signOut, user }) {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleNetworkChange = () => {
      if (navigator.onLine) {
        setIsOnline(true);
      } else {
        setIsOnline(false);
      }
    };

    window.addEventListener('online', handleNetworkChange);
    window.addEventListener('offline', handleNetworkChange);

    return () => {
      window.removeEventListener('online', handleNetworkChange);
      window.removeEventListener('offline', handleNetworkChange);
    };
  }, []);
  return (
    <Layout
      style={{
        height: '100%',
      }}
    >
      <Wrapper>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 0.1fr',
        }}>
          <Orders accountId={user.attributes.nickname} />
          <Blink isOnline={isOnline} />
        </div>
        <Clock signOut={signOut} />
      </Wrapper>
    </Layout>
  )
}

export default withAuthenticator(App, { hideSignUp: true });